import { Component } from '@angular/core';

@Component({
  selector: 'ui-skeleton-table',
  standalone: true,
  templateUrl: './skeleton-table.component.html',
})
export class UISkeletonTableComponent {}
